import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import userGroupsSlice from '../reducers/userGroups.slice'

const persistConfig = {
  key: 'userGroupsSlice',
  storage,
}

export const persistedUserGroupsReducer = persistReducer(persistConfig, userGroupsSlice)